<template>
	<div v-if="testingDocumentsForm" class="py-8 flex flex-col 2xl:flex-row gap-8 justify-stretch 2xl:items-start">
		<div class="flex-1">
			<FirmwareTestingDocumentsForm
					:form="testingDocumentsForm"
					@on-save="saveFirmwareTestingDocument"
					:selected-firmware="$attrs.firmware"
			/>
		</div>
		<div class="flex-1">
			<FirmwareTestingDocumentsList
					:selected-firmware="$attrs.firmware"
					@on-delete="deleteFirmwareTestingDocument"
					@on-download="downloadFirmwareTestingDocument"
			/>
		</div>
	</div>
</template>

<script>
import FirmwareTestingDocumentsForm from "@/Forms/Firmware/FirmwareTestingDocumentsForm.vue";
import { mapStores } from "pinia";
import { useFirmwareTestingDocumentsStore } from "@/stores/firmwareTestingDocument.js";
import FirmwareTestingDocumentsList from "@/Forms/Firmware/FirmwareTestingDocumentsList.vue";
import { useDownloadLink } from "@/Composables/DownloadLink.js";

export default {
	name: "FirmwareTestingDocumentsView",
	components: {FirmwareTestingDocumentsList, FirmwareTestingDocumentsForm},
	data() {
		return {
			testingDocumentsForm: undefined,
		}
	},
	computed: {
		...mapStores(useFirmwareTestingDocumentsStore)
	},
	methods: {
		async saveFirmwareTestingDocument() {
			try {
				const response = await this.testingDocumentsForm.submit();
				this.testingDocumentsForm.reset();
				this.$emit('on-save');
			} catch (error) {
				//
			}
		},
		async deleteFirmwareTestingDocument(firmwareTestingDocument) {
			if (firmwareTestingDocument) {
				await this.firmwareTestingDocumentsStore.deleteFirmwareTestingDocument(firmwareTestingDocument.id);
				this.$emit('on-save');
			}
		},
		async downloadFirmwareTestingDocument(firmwareTestingDocument) {
			if (firmwareTestingDocument) {
				try {
					const response = await this.firmwareTestingDocumentsStore.showFirmwareTestingDocument(firmwareTestingDocument.id, { download: 1 });
					useDownloadLink(response.url);
				} catch (error) {
					console.log('Error downloading firmware testing document', error);
				}
			}
		},
	},
	watch: {
		'$route.params.firmware': {
			async handler(newValue, oldValue) {
				if (newValue) {
					this.testingDocumentsForm = await this.firmwareTestingDocumentsStore.createFirmwareTestingDocument();
					this.testingDocumentsForm.firmware_id = this.$attrs.firmware.id;
				} else {
					this.testingDocumentsForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>